export default class BranchIoService {
  constructor($http, env, AuthService, $timeout, $window) {
    this.$http = $http;
    this.$env = env;
    this.$auth = AuthService;
    this.$timeout = $timeout;
    this.$window = $window;

    const key = this.$env.EnvironmentConfig.branchio_api_key;

    this.init = false;

    branch.init(key, (err, data) => {
      console.log("branch", err, data);
      this.init = true;
    });
  }

  createLink(jobbleId, title) {
    let origin = this.getOrigin();
    console.log(`Branch IO Origin: ${origin}`);

    const linkData = {
      title: title,
      channel: "email",
      feature: "web_job_share",
      data: {
        jobbleId: jobbleId,
        $desktop_url: `${origin}/job/${jobbleId}`,
        $og_title: title,
      },
    };

    return new Promise((resolve, reject) => {
      branch.link(linkData, (err, link) => {
        console.log("branch link generated", link);
        resolve(link);
      });
    });
  }

  getOrigin() {
    let origin = this.$window.location.origin;

    if (origin.indexOf("localhost") !== -1) {
      if (this.$env.EnvironmentConfig.api.indexOf("api-qa") !== -1) {
        origin = "https://app-qa.int.jobbleapp.com";
      } else if (this.$env.EnvironmentConfig.api.indexOf("api-eb") !== -1) {
        origin = "https://app.jobble.com";
      } else if (this.$env.EnvironmentConfig.api.indexOf("api.alef.") !== -1) {
        origin = "https://app.alef.jobbleapp.com";
      } else {
        origin = "https://app.jobble.com";
      }
    }

    return origin;
  }

  createLinks(jobbleId, title, company, partner_url) {
    let origin = this.getOrigin();
    console.log(`Branch IO Origin: ${origin}`);

    let linkData = {
      title: title,
      channel: "email",
      feature: "web_job_share",
      data: {
        jobbleId: jobbleId,
        partner_url: partner_url,
        $deeplink_path: `job?id=${jobbleId}`,
        $desktop_url: `${origin}/job/${jobbleId}`,
        $og_title: title,
        $og_description: company,
      },
    };

    const channels = ["email", "facebook", "twitter", "linkedin"];

    const promises = channels.map((channel) => {
      return new Promise((resolve, reject) => {
        let data = JSON.parse(JSON.stringify(linkData));
        data.channel = channel;
        branch.link(data, (err, link) => {
          console.log("branch link generated", link, data);
          resolve(link);
        });
      });
    });

    return Promise.all(promises).then((links) => {
      let data = {};

      for (let i = 0; i < channels.length; i++) {
        data[channels[i]] = links[i];
      }

      return data;
    });
  }
}

BranchIoService.$inject = ["$http", "env", "auth", "$timeout", "$window"];



// WEBPACK FOOTER //
// ./client/app/services/branchio.js